export const API_ENDPOINT = {
  REGISTER_USER: "/api/v1/auth/register",
  LOGIN_USER: "/api/v1/auth/login",
  GOOGLE_OAUTH: "api/v1/auth/google",
  GET_ME: "/api/v1/auth/me",
  MOVIE_POPULAR: "/api/v1/movie/popular",
  DETAIL_MOVIE: "/api/v1/movie",
  SEARCH_MOVIE: "/api/v1/search/movie",
};
